export enum ProductAnalyticsEvents {
  // Admin Settings
  AdminUserGroupUpdate = "admin_settings:user_group_update",
  AdminUserActiveUpdate = "admin_settings:user_active_update",
  AdminNewUserInvite = "admin_settings:new_user_invite",

  // Forecast Charts
  ForecastMeteogramDataView = "forecast_charts:meteogram_data_view",
  ForecastMeteogramDataPastView = "forecast_charts:meteogram_data_past_view",
  ForecastSensorDataView = "forecast_charts:sensor_data_view",
  ForecastProbabilisticDataView = "forecast_charts:probabilistic_data_view",
  ForecastDataShare = "forecast_charts:data_share",
  ForecastReportGenerate = "forecast_charts:report_generate",
  ForecastTableDataView = "forecast_charts:table_data_view",
  ForecastMeteogramInsightDataView = "forecast_charts:meteogram_insight_data_view",
  ForecastMultipointInsightDataView = "forecast_charts:multipoint_insight_data_view", // GEOESPACIAL

  // River Forecasts
  RiverForecastsProbabilisticDataView = "river_forecasts:probabilistic_data_view",

  // Occurrence
  OccurrenceCreate = "occurrence:create",
  OccurrenceFileUpload = "occurrence:file_upload",

  // Insight
  InsightChartDataView = "insight:chart_data_view",
  InsightChartPastDataView = "insight:chart_past_data_view",
  InsightChartProbabilistic = "insight:chart_probabilistic_view",
  InsightChartProbabilisticOn = "insight:chart_probabilistic_on",
  InsightChartProbabilisticOff = "insight:chart_probabilistic_off",
  InsightChartProbabilisticTutorialOpen = "insight:chart_probabilistic_tutorial_open",
  InsightChartProbabilisticFeedback = "insight:chart_probabilistic_feedback",

  // User Config
  UserConfigUnitMeasurementUpdate = "user_config:unit_measurement_update",
  UserConfigLanguageUpdate = "user_config:language_update",

  //Mobile
  MobileForecastTrendsDataView = "mobile:forecast_trends_view",
  MobileForecastChartDataView = "mobile:forecast_chart_data_view",

  //OperationService
  OperationServiceCreate = "operation_service:create",
  OperationServiceUpdate = "operation_service:update",
  OperationServiceInsightChartDataView = "operation_service:shift_gantt_data_view",

  //ForecastRadarLayer
  ForecastRadarLayerMapView = "forecast_charts:radar_layer_map_view",
  ForecastRadarLayerMapStart = "forecast_charts:radar_layer_map_start",

  //ForecastLayer
  ForecastLayerMapView = "forecast_charts:forecast_layer_map_view",
  ForecastLayerMapStart = "forecast_charts:forecast_layer_map_start",
}
